import { QuizImportMethods } from '@showbie-socrative/socrative-utils/lib/consts/enums';

import { CreateQuizEventAdapter } from '~analytics/adapters/CreateQuizEventAdapter';
import { PaywallScreens } from '~analytics/types';
import { PaywallDispatch } from '~teacher/components/PaywallDialog';
import {
  QuizToastActions,
  apiToaster,
} from '~teacher/components/quizzes/toastActions';
import { useQuizLimit } from '~teacher/hook';
import {
  handleImportQuizError,
  useImportQuizToPersonalBySocMutation,
} from '~teacher/hook/useImportQuizToPersonalBySocMutation';

interface UseImportBySocParams {
  parentId?: number;
  paywallDispatch: PaywallDispatch;
}

export function useImportBySoc({
  parentId = null,
  paywallDispatch,
}: UseImportBySocParams) {
  const quizLimit = useQuizLimit();
  const importQuizBySocMutation = useImportQuizToPersonalBySocMutation(
    QuizImportMethods.ByQuizShop
  );

  const importQuiz = (socNumber: string) => {
    if (quizLimit.data?.currentQuizCount + 1 > quizLimit.data?.limit) {
      paywallDispatch({
        type: 'OPEN',
        touch: [
          PaywallScreens.QuizListLimitReached,
          PaywallScreens.DiscoveryImportQuiz,
        ],
      });
    } else {
      importQuizBySocMutation.mutate(
        { socNumber: socNumber, parentId: parentId },
        {
          onSuccess: (response) => {
            apiToaster([], QuizToastActions.IMPORT);

            // Send analytics
            new CreateQuizEventAdapter({
              creation_method: 'quiz_shop',
              source_soc_number: response['originalSocNumber'],
            }).sendAnalytics();
          },
          onError: handleImportQuizError(() => {
            /**
             * If we are over the quiz limit, we display the paywall.
             */
            paywallDispatch({
              type: 'OPEN',
              touch: [
                PaywallScreens.QuizListLimitReached,
                PaywallScreens.DiscoveryImportQuiz,
              ],
            });
          }),
        }
      );
    }
  };

  return { ...importQuizBySocMutation, importQuiz };
}
